module.exports = __webpack_public_path__ + "img/capture.e05157b9.svg";